/* Touch-safe controls, including dynamically replaced cart/filter content. */
(() => {
  if (window.sweetbarControlsReady) return;
  window.sweetbarControlsReady = true;
  const root = document.documentElement;
  root.dataset.sbInput = 'pointer';
  document.addEventListener('pointerdown', () => { root.dataset.sbInput = 'pointer'; }, true);
  document.addEventListener('keydown', (event) => { if (event.key === 'Tab') root.dataset.sbInput = 'keyboard'; }, true);
  const controls = 'a, button, summary, [role="button"]';
  const editable = 'input, textarea, select, [contenteditable]:not([contenteditable="false"])';
  // Disable native link/image drag before a pointer or long press begins.
  // Delegation also covers links inserted by cart, search and filter updates.
  const prepareControl = (event) => {
    if (window.Shopify?.designMode) return;
    const target = event.target instanceof Element ? event.target : event.target?.parentElement;
    if (!target || target.closest(editable)) return;
    const control = target.closest(controls);
    if (!control) return;
    control.setAttribute('draggable', 'false');
    if (target !== control) target.setAttribute('draggable', 'false');
  };
  if (!window.Shopify?.designMode) {
    document.querySelectorAll(controls).forEach((control) => {
      control.setAttribute('draggable', 'false');
    });
  }
  document.addEventListener('pointerdown', prepareControl, true);
  document.addEventListener('touchstart', prepareControl, { capture: true, passive: true });
  const preventControlDrag = (event) => {
    if (window.Shopify?.designMode) return;
    const target = event.target instanceof Element ? event.target : event.target?.parentElement;
    if (target && !target.closest(editable) && target.closest(controls) && event.cancelable) event.preventDefault();
  };
  document.addEventListener('dragstart', preventControlDrag, true);
  document.addEventListener('selectstart', preventControlDrag, true);
  document.addEventListener('contextmenu', preventControlDrag, true);
})();
